import React, { useCallback } from "react";

import { useAppDispatch } from "cortex/ui/src/hooks";

import { FetchOptions } from "./fetchOptions";

type ResolveRejectPayload<T = unknown> = {
  reject: (reason?: unknown) => void;
  resolve: (value?: T | PromiseLike<T>) => void;
};

type FetchActionCreator<T = unknown> = (
  payload: ResolveRejectPayload<T>,
) => unknown;

type UnloadActionCreator = () => unknown;
type UnloadAction = unknown;

export function fetchOptionFactory<T = unknown>(
  fetchAction: FetchActionCreator<T>,
  unloadAction: UnloadActionCreator | UnloadAction,
) {
  function FetchOptionProvider() {
    const dispatch = useAppDispatch();

    const fetch = useCallback((): Promise<T> => {
      return new Promise<T>((resolve, reject) => {
        const resolvePayload: ResolveRejectPayload<T>["resolve"] = (value) => {
          resolve(value as T | PromiseLike<T>);
        };

        dispatch(fetchAction({ resolve: resolvePayload, reject }) as any);
      });
    }, [dispatch, fetchAction]);

    const unload = useCallback((): void => {
      dispatch(
        (typeof unloadAction === "function"
          ? unloadAction()
          : unloadAction) as any,
      );
    }, [dispatch, unloadAction]);

    return <FetchOptions fetch={fetch} unload={unload} />;
  }

  return FetchOptionProvider;
}
